// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2l0xL","disabled":"FileBtn_disabled__2guNf","warn":"FileBtn_warn__1exU8","fade":"FileBtn_fade__1swWQ"};